// src/pages/Pricing.jsx
import ComingSoon from '../components/ComingSoon';

const Pricing = () => {
  return <ComingSoon pageName="Pricing Plans" />;
};
export default Pricing;